<template>
  <div>
    <div class="news">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="center">
        <div class="module">
          <titleTemp2 :data="centerData"></titleTemp2>
          <div class="list">
            <div>
              <div class="left">
                <div class="title">30</div>
                <div class="subtitle">2018/03</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails10'">祝贺臻图科技GIS空间引擎软件V1.0成功通过……</div>
                <div class="subtitle">由我司研发的自主知识产权的GIS空间引擎软件，参加上海市科技企业创新项目评审……</div>
                <div class="mores" v-jump="'/news/newsdetails10'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">05</div>
                <div class="subtitle">2017/11</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails9'">臻图科技亮相第十一届中国智慧城市技术建……</div>
                <div class="subtitle">11月3日上午9点，第十一届中国智慧城市技术建设技术研讨会暨设备博览会在北京国际会议中心隆重开幕……</div>
                <div class="mores" v-jump="'/news/newsdetails9'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">02</div>
                <div class="subtitle">2016/08</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails8'">臻图科技成功中标海信集团海上云GIS共享平……</div>
                <div class="subtitle">由我司研发的自主知识产权的GIS空间引擎软件，参加上海市科技企业创新项目评审……</div>
                <div class="mores" v-jump="'/news/newsdetails8'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">12</div>
                <div class="subtitle">2016/06</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails7'">成功中标中科院土地空间数据GIS共享平台项目</div>
                <div class="subtitle">经过对项目需求的分析和调研，凭借对行业的了解以及专业技术实力优势，我司成功中标中科院土地空间数据GIS……</div>
                <div class="mores" v-jump="'/news/newsdetails7'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">16</div>
                <div class="subtitle">2016/05</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails6'">我司获得上海市科技创业基金会的立项支持</div>
                <div class="subtitle">在经历了基金会的摸底调研和数轮答辩后，我司凭借“高性价比自主知识产权的ZTMapGIS平台”项目，获得各专业……</div>
                <div class="mores" v-jump="'/news/newsdetails6'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">23</div>
                <div class="subtitle">2016/04</div>
              </div>
              <div class="right">
                <div class="title">ZTMap智慧旅游产品正式上线！</div>
                <div
                  class="subtitle"
                  v-jump="'/news/newsdetails5'"
                >ZTMap智慧旅游产品是基于自主知识产权的GIS平台ZTMap开发的，适用于旅游景区应用的可视化产品……</div>
                <div class="mores" v-jump="'/news/newsdetails5'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">23</div>
                <div class="subtitle">2016/04</div>
              </div>
              <div class="right">
                <div class="title">ZTMap GIS V1.1 正式发布！</div>
                <div
                  class="subtitle"
                  v-jump="'/news/newsdetails4'"
                >ZTMap GIS V1.1版本正式发布，ZTMap平台产品在经历了V1.0版本两年多的成功应用后，经过深度优化和……</div>
                <div class="mores" v-jump="'/news/newsdetails4'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">21</div>
                <div class="subtitle">2016/03</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails3'">我司成为上海移动合格供应商</div>
                <div class="subtitle">依靠强劲的技术实力和优质的技术服务，我司正式成为上海移动的合格供应商，并成功为其实施基于GIS的内网……</div>
                <div class="mores" v-jump="'/news/newsdetails3'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">13</div>
                <div class="subtitle">2016/01</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails2'">祝贺公司“ZTMap高性价比GIS平台产品V1.0……</div>
                <div class="subtitle">我司研发的自主知识产权的GIS产品“ZTMap高性价比GIS平台产品V1.0” ，参加上海市闵行区科技企业创新项目评审……</div>
                <div class="mores" v-jump="'/news/newsdetails2'">查看更多</div>
              </div>
            </div>
            <div>
              <div class="left">
                <div class="title">04</div>
                <div class="subtitle">2015/05</div>
              </div>
              <div class="right">
                <div class="title" v-jump="'/news/newsdetails1'">公司成功参与智慧城市项目建设</div>
                <div class="subtitle">经过数月的前期技术交流和DEMO演示，公司成功参与到河南某市的智慧城市建设，参与承担智慧城管平台的建设……</div>
                <div class="mores" v-jump="'/news/newsdetails1'">查看更多</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-news">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="content">
        <div class="titles">
          <div class="title">{{centerData.title}}</div>
          <div class="en-title">{{ centerData.subtitle }}</div>
        </div>
        <div class="list1">
          <div class="item" v-for="(item, index) in newsList" :key="index" @click="toDetail(item.id)">
            <div class="time">
              <p class="day">{{ item.time.slice(8) }}</p>
              <p class="year">{{ item.time.slice(0, 7).replace('-', '/') }}</p>
            </div>
            <div class="item-container">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-content">{{ item.p[0] }}</div>
              <div class="see-more"><a :href="'/news/newsdetails' + item.id">了解更多 >> </a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "News",
  metaInfo: {
    title: "新闻动态-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "三维可视化,三维渲染,智慧城市可视化"
      },
      {
        name: "description",
        content:
          "智慧城市三维可视化行业及公司新闻动态。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "新闻动态",
        p: ""
      },
      centerData: {
        title: "新闻动态",
        subtitle: "PRESS INFORMATION"
      },
      newsList: [
        {
          time: "2018-03-30",
          title: "祝贺臻图科技GIS空间引擎软件V1.0成功通过科委科技成果验收",
          p: [
            "由我司研发的自主知识产权的GIS空间引擎软件，参加上海市科技企业创新项目评审，经过专家的层层评审，凭借独特的技术和应用创新优势，以及全面超预期完成的指标数据，获得专家委员会的一致认可，成功验收。这标志着臻图科技在GIS大数据服务方面已建立了一套科学有效的管理体系，同时也意味着臻图科技在空间信息服务能力和水平上达到了一定的国内领先和国际先进水准。"
          ],
          id: 10
        },
        {
          time: "2017-11-05",
          title: "臻图科技亮相第十一届中国智慧城市技术建设技术研讨会",
          p: [
            "11月3日上午9点，第十一届中国智慧城市技术建设技术研讨会暨设备博览会在北京国际会议中心隆重开幕。上海臻图信息技术有限公司作为参展商受邀出席研讨会暨博览会。",
            "展会上众多智慧城市建设领域的科研机构，行业联盟，通讯运营商等，对臻图科技的智慧城市GIS平台很感兴趣，其中多家测绘地理信息单位、物联网企业分别看重臻图科技的智慧社区平台、智能商业平台等，现场工作人员分别为他们做了相关平台的演示操作，并进行了深入地沟通，他们对臻图科技的平台运作模式、系统功能等给予了高度肯定。",
            "本次邀请智慧城市（含智慧园区、智慧社区等）建设管理部门，智慧城市建设领域的科研机构，行业联盟，通讯运营商，跨国公司及国内外知名软、硬件企业参加智慧城市大会展览，展示国内外最新技术、产品与应用成果。作为国内卓越的GIS行业信息化领军企业，臻图科技专业的科技化企业形象、丰富多样的产品服务备受瞩目。",
            "前来参观交流的企业和领导给了公司及团队很大的肯定和鼓舞，臻图科技会以更专业、高效、创新的产品及解决方案积极参与到智慧城市的建设中来。"
          ],
          id: 9
        },
        {
          time: "2016-08-02",
          title: "臻图科技成功中标海信集团海上云GIS共享平台项目",
          p: [
            " 2016年8月1日，凭借我司对GIS行业的了解以及专业技术优势，通过对青岛海信集团海上云GIS项目的分析和理解，我司成功中标海信集团海上云GIS共享平台项目。"
          ],
          id: 8
        },
        {
          time: "2016-06-12",
          title: "成功中标中科院土地空间数据GIS共享平台项目",
          p: [
            "经过对项目需求的分析和调研，凭借对行业的了解以及专业技术实力优势，我司成功中标中科院土地空间数据GIS共享平台项目。"
          ],
          id: 7
        },
        {
          time: "2016-05-16",
          title: "我司获得上海市科技创业基金会的立项支持",
          p: [
            " 在经历了基金会的摸底调研和数轮答辩后，我司凭借“高性价比自主知识产权的ZTMapGIS平台”项目，获得各专业和投资专家的一致认可，正式决定对我们公司进行立项支持，我司将作为上海市科技创业基金会的重点支持和孵化企业，基金会将在资金和指导服务方面为我司注入强大的动力。",
            "这是公司持续创新、永续经验道路上的一个重要推动力，扩宽了公司的不断发展壮大之路！",
            "（上海市科技创业基金会是政府组织成立的，由各级政府科委、财政部门牵头，各大VC投资公司、银行等参与的机构，致力于为上海市科技型创新企业提供政策和资金扶持）"
          ],
          id: 6
        },
        {
          time: "2016-04-23",
          title: "ZTMap智慧旅游产品正式上线！",
          p: [
            "ZTMap智慧旅游产品是基于自主知识产权的GIS平台ZTMap开发的，适用于旅游景区应用的可视化产品，实现了基于微信、APP的手机景区地图浏览查询和智能游览功能，用户可以基于微信公众号或APP实现景区地图的随时查看，实现二三维地图、三维全景、自动路线游览等丰富的功能。"
          ],
          id: 5
        },
        {
          time: "2016-04-23",
          title: "ZTMap GIS V1.1 正式发布！",
          p: [
            "ZTMap GIS V1.1版本正式发布，ZTMap平台产品在经历了V1.0版本两年多的成功应用后，经过深度优化和最新技术的应用，成功研发成功V1.1版本，该版本在地图前端渲染的效率和效果方面得到了大幅提升，同时在跨平台兼容性方面进行了更为深入的开发，该产品将会为用户带来业界领先的地图用户体验。"
          ],
          id: 4
        },
        {
          time: "2016-03-21",
          title: "我司成为上海移动合格供应商",
          p: [
            "依靠强劲的技术实力和优质的技术服务，我司正式成为上海移动的合格供应商，并成功为其实施基于GIS的内网可视化资产管理系统的合作开发。 这标志着我们的产品和服务获得了顶级服务商的认可。"
          ],
          id: 3
        },
        {
          time: "2016-01-13",
          title:
            "祝贺公司“ZTMap高性价比GIS平台产品V1.0”获得闵行区科技创新项目立项",
          p: [
            "我司研发的自主知识产权的GIS产品“ZTMap高性价比GIS平台产品V1.0” ，参加上海市闵行区科技企业创新项目评审，经过专家的层层评审，凭借独特的技术和应用创新优势，获得专家委员会的一致认可，获得科委的立项支持。这标志着我们立足技术创新战略获得认可，是对我们公司团队的极大激励和支持。我们定会坚持以市场为导向，以创新为根本，继续努力！"
          ],
          id: 2
        },
        {
          time: "2015-05-04",
          title: "公司成功参与智慧城市项目建设",
          p: [
            "经过数月的前期技术交流和DEMO演示，公司成功参与到河南某市的智慧城市建设，参与承担智慧城管平台的建设，ZTMap产品将在该平台的建设中充分发挥地图服务技术的优势特点，使其成为该平台的一大亮点。"
          ],
          id: 1
        }
      ]
    };
  },
  methods: {
    toDetail(id) {
      window.location.href = `/news/newsdetails${id}`
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/news/banner.jpg");
}
.news {
  .center {
    padding: 100px 0 150px 0;
    .list {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      > div {
        width: 573px;
        height: 120px;
        display: inline-block;
        margin-bottom: 60px;
        &:nth-of-type(2n + 1) {
          margin-right: 42px;
        }
        &:nth-of-type(9),
        &:nth-of-type(10) {
          margin-bottom: 0;
        }
        .left {
          width: 120px;
          height: 120px;
          background: #69c0ff;
          color: #fff;
          text-align: center;
          float: left;
          .title {
            font-size: 30px;
            margin: 20px 0 10px 0;
            line-height: 42px;
          }
          .subtitle {
            font-size: 20px;
            line-height: 28px;
          }
        }
        .right {
          float: right;
          width: 435px;
          position: relative;
          height: 100%;
          .title {
            font-size: 20px;
            color: rgba(75, 75, 75, 1);
            line-height: 28px;
            cursor: pointer;
          }
          .subtitle {
            font-size: 16px;
            color: rgba(124, 124, 124, 1);
            line-height: 22px;
            margin-top: 10px;
          }
          .mores {
            font-size: 14px;
            color: rgba(2, 118, 247, 1);
            line-height: 20px;
            position: absolute;
            bottom: 0;
            right: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.mobile-news {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/news/banner.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    box-sizing: border-box;
    padding: 2rem;
    .titles {
      width: 100%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: "Normal";
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999999;
      }
    }
    .list1 {
      width: 100%;
      display: flex;

      flex-direction: column;
      .item {
        width: 100%;
        height: 10rem;
        display: flex;
        align-items: center;
        margin-top: 2rem;
        .time {
          width: 10rem;
          height: 10rem;
          flex-shrink: 0;
          background: #69c0ff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #fff;
          p {
            margin: 0;
          }
          .day {
            font-size: 1.8rem;
            font-weight: bold;
            line-height: 3rem;
          }
          .year {
            font-size: 1.2rem;
            line-height: 2rem;
          }
        }
        .item-container {
          width: 22.5rem;
          box-sizing: border-box;
          padding-left: 1rem;
          height: 100%;
          .item-title {
            width: 100%;
            font-size: 1.4rem;
            font-weight: bold;
            line-height: 2rem;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            color: #333333;
          }
          .item-content {
            width: 100%;
            font-size: 1rem;
            font-weight: normal;
            line-height: 1.5rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            margin-top: 1rem;
            color: #333333;
          }
          .see-more {
            width: 100%;
            font-size: 1rem;
            font-weight: 350;
            line-height: 1.5rem;
            text-align: right;
            color: #3C80E8;
            margin-top: 1rem;
            box-sizing: border-box;
            padding-right: 1rem;
            a {
              color: #3C80E8;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .news {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-news { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/news.vue